var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRealPennedPostcard = function SvgRealPennedPostcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 43"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M25.962 41h-15.7A8.263 8.263 0 0 1 2 32.737V10.263C2 5.699 5.7 2 10.263 2h22.474C37.301 2 41 5.7 41 10.263v15.823M10.262 10.758h22.495M10.262 17.369h22.475M10.262 23.979h5.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M39.718 39.718a4.38 4.38 0 0 0 0-6.194l-5.793-5.793a10.3 10.3 0 0 0-5.264-2.816l-4.682-.936.936 4.682a10.3 10.3 0 0 0 2.817 5.264l5.792 5.793a4.38 4.38 0 0 0 6.194 0"
  })));
};
export default SvgRealPennedPostcard;